module.exports = __webpack_public_path__ + "03397ad1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/p_login/ThirdLogin/weibo.png
// module id = 1189
// module chunks = 7